module.exports = __webpack_public_path__ + "img/headphone_1000.ba34be8a.png";